import React, { useContext, useEffect, useState } from 'react';
import axios from 'axios';
import { Button, Container, Form } from 'react-bootstrap';
import { Helmet } from 'react-helmet-async';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Store } from '../Store';
import { toast } from 'react-toastify';
import { getError } from '../utils';

export default function EcranConnexion() {
  const naviguer = useNavigate();
  const { search } = useLocation();
  const redirectInUrl = new URLSearchParams(search).get('redirect');
  const redirect = redirectInUrl ? redirectInUrl : '/';

  const [email, setEmail] = useState('');
  const [mdp, setMdp] = useState('');

  const { state, dispatch: ctxDispatch } = useContext(Store);
  const { infoUtilisateur } = state;
  const gestionValidation = async (e) => {
    e.preventDefault();
    try {
      const { data } = await axios.post('/api/utilisateurs/signin', {
        email,
        mdp,
      });
      ctxDispatch({ type: 'CONNEXION_UTILISATEUR', payload: data });
      localStorage.setItem('infoUtilisateur', JSON.stringify(data));
      naviguer(redirect || '/');
    } catch (err) {
      toast.error(getError(err));
    }
  };

  useEffect(() => {
    if (infoUtilisateur) {
      naviguer(redirect);
    }
  }, [naviguer, redirect, infoUtilisateur]);

  return (
    <Container className="small-container">
      <Helmet>
        <title>Connexion</title>
      </Helmet>
      <h1 className="my-3">Connexion</h1>
      <Form onSubmit={gestionValidation}>
        <Form.Group className="mb-3" controlId="email">
          <Form.Label>Email</Form.Label>
          <Form.Control
            type="email"
            required
            onChange={(e) => setEmail(e.target.value)}
          ></Form.Control>
        </Form.Group>
        <Form.Group className="mb-3" controlId="password">
          <Form.Label>Mot de passe</Form.Label>
          <Form.Control
            type="password"
            required
            onChange={(e) => setMdp(e.target.value)}
          ></Form.Control>
        </Form.Group>
        <div className="mb-3">
          <Button type="submit" className="shadow-none">
            Connexion
          </Button>
        </div>
        <div className="mb-3">
          Nouveau client ?{' '}
          <Link to={`/inscription?redirect=${redirect}`}>Créer un compte</Link>
        </div>
      </Form>
    </Container>
  );
}
